import React, { useEffect, useState } from 'react'
import styles from './displays__addLicenses.jcss'
import translate from '../../../core/translate'
import { api } from '../../../core/api/ConnectionManager'
import Dropdown from '../../../blocks.simple/dropdown/dropdown'
import { licenseType, rateTypeRename } from '../../../core/utils/displayUtil'
import { cn } from 'ethcss'
import moment from 'moment'
import Button from '../../../blocks.simple/button/button'
import { ISelectedItems } from '../__toolbarContent/displays__toolbarContent'
import { IDevice } from '../../../core/models/DigitalSignage'
import LoaderItem from '../../../blocks.app/loader/__item/loader__item'

export const AddLicenses = ({ onClose, selectedItems }: { onClose: () => void; selectedItems: ISelectedItems[] }) => {
    const [licenses, setLicenses] = useState<any>([])
    const [selectedLicenseId, setSelectedLicenseId] = useState<number | null>(null)
    const [devices, setDevices] = useState<IDevice[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const renderCustomOptions = (option: any) => {
        return (
            <div className={cn(styles.licenseOption, option.vacantCount < devices.length ? styles.disabled : '')}>
                <div className={styles.licenseOptionRow} style={{ marginBottom: option.id ? 6 : 0 }}>
                    <div className={styles.licenseOptionName}>{option.name}</div>
                    {option.id && (
                        <div className={styles.licenseOptionDesc}>
                            {translate('licenseIdN')}: <span>{option.id}</span>
                        </div>
                    )}
                </div>
                {option.id && (
                    <div className={styles.licenseOptionRow}>
                        <div className={styles.licenseOptionDesc}>
                            {translate('freeN')}:{' '}
                            <span>
                                {option.vacantCount}/<span>{option.devicesCount}</span>
                            </span>
                        </div>
                        <div className={styles.licenseOptionDesc}>
                            {translate('activeBeforeN')}:{' '}
                            <span>
                                {option.expiredAt
                                    ? moment(option.expiredAt).format('DD.MM.YYYY')
                                    : translate('foreverN')}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const renderCustomSelected = (licenseId: any) => {
        const license = licenses.find((item: { id: string }) => item.id === licenseId)
        return (
            license && (
                <div>
                    <div className={cn(styles.licenseOptionRow)}>
                        <div className={styles.licenseOptionName}>{license.name}</div>
                        <div className={cn(styles.licenseHeaderDesc, styles.licenseOptionMob)}>
                            {translate('licenseIdN')}: <span>{license.id}</span>
                        </div>
                    </div>
                    <div className={cn(styles.licenseOptionRow, styles.licenseOptionMob)}>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('freeN')}:{' '}
                            <span>
                                {license.vacantCount}/<span>{license.devicesCount}</span>
                            </span>
                        </div>
                        <div className={styles.licenseHeaderDesc}>
                            {translate('activeBeforeN')}:{' '}
                            <span>
                                {license.expiredAt
                                    ? moment(license.expiredAt).format('DD.MM.YYYY')
                                    : translate('foreverN')}
                            </span>
                        </div>
                    </div>
                </div>
            )
        )
    }

    const getLicenseInfoByLicenseId = (licenseId: number | null) => {
        if (!licenseId) return '-'

        const license = licenses.find((license: any) => license.id === licenseId)

        if (license) {
            return license.name
        }

        return '-'
    }

    const removeDevice = (id: number) => {
        setDevices(devices.filter((device) => device.id !== id))
    }

    const setLicenseData = () => {
        api.send('digitalSignagesSetLicense', {
            digitalSignageId: devices.map((device) => device.id),
            licenseId: selectedLicenseId,
        }).then(() => {
            onClose()
        })
    }

    const validateLicense = () => {
        if (selectedLicenseId) {
            const license = licenses.find((license: any) => license.id === selectedLicenseId)

            if (license) {
                return license.vacantCount >= devices.length
            }
        }

        return true
    }

    useEffect(() => {
        if (selectedItems.length) {
            const groupId: number[] = []
            const digitalSignageId: number[] = []

            selectedItems.forEach((device) => {
                if (device.type === 'group') {
                    groupId.push(device.id)
                } else {
                    digitalSignageId.push(device.id)
                }
            })

            api.send('getDisplaysFromGroups', {
                groupId,
                digitalSignageId,
                fields: ['id', 'name', 'licenseId'],
            }).then((displays: any) => {
                setDevices(displays)
            })
        }
    }, [])

    useEffect(() => {
        api.send('getLicenseByFilters', {
            sort: [['licenseId', 'ASC']],
            limit: 1000,
            companyId: 8,
        }).then((res: any) => {
            let optionFormat = res.data
                .filter((data: any) => data.activeQ)
                .map((opt: any) => ({
                    id: opt.licenseId,
                    name: licenseType(opt) + ' ' + rateTypeRename(opt.rateType),
                    vacantCount: opt.vacantCount,
                    devicesCount: opt.devicesCount,
                    expiredAt: opt.expiredAt,
                    paidQ: opt.paidQ,
                }))

            setLicenses(optionFormat)
        })
    }, [])

    useEffect(() => {
        if (isLoading && devices.length && licenses.length) {
            setIsLoading(false)
        }
    }, [devices, licenses])

    return (
        <div className={styles.wrapper}>
            <div className={styles.addLicenses}>
                {!!devices.length && !!licenses.length ? (
                    <>
                        <div className={styles.title}>{translate('licensesAsset')}</div>
                        <div className={styles.description}>
                            {translate(
                                devices.some((device) => device.licenseId)
                                    ? 'selectedDeviceWithLicense'
                                    : 'selectLicenseForAsset'
                            )}
                        </div>
                        <div className={styles.licenseSelector}>
                            <span>{translate('licensesType')}</span>
                            {!!licenses.length && (
                                <Dropdown
                                    id="licensesDataEdit"
                                    value={selectedLicenseId}
                                    customListElement={renderCustomOptions}
                                    customButtonContent={renderCustomSelected(selectedLicenseId)}
                                    options={[
                                        {
                                            name: translate('notSelected'),
                                            id: null,
                                        },
                                        ...licenses,
                                    ]}
                                    centered
                                    onChange={(selected) => {
                                        setSelectedLicenseId(selected.id)
                                    }}
                                    placeholder={translate('notSelected')}
                                    buttonClassName={styles.licenseDropdown}
                                />
                            )}
                        </div>
                        {!validateLicense() && (
                            <div className={styles.notAvailable}>{translate('notEnoughLicenses')}</div>
                        )}
                        <div className={styles.devicesSection}>
                            <div className={cn(styles.devicesRow, styles.devicesHeader)}>
                                <div className={styles.devicesCol}>
                                    {translate('selectedDevices')}: {devices.length}
                                </div>
                                <div className={styles.devicesCol}>{translate('license1')}</div>
                            </div>
                            <div className={styles.devicesList}>
                                {devices.map((device) => (
                                    <div className={styles.devicesRow} key={device.id}>
                                        <div className={styles.devicesCol}>{device.name}</div>
                                        <div className={cn(styles.devicesCol, styles.devicesColRight)}>
                                            {getLicenseInfoByLicenseId(device.licenseId)}
                                        </div>
                                        <div className={styles.removeDevice} onClick={() => removeDevice(device.id)}>
                                            -
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className={styles.buttons}>
                                <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                                    {translate('close')}
                                </Button>
                                <Button
                                    className={styles.button}
                                    mod={'fill'}
                                    onClick={setLicenseData}
                                    disabled={!selectedLicenseId || !validateLicense()}
                                >
                                    {translate('apply')}
                                </Button>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className={styles.loader}>
                        {isLoading ? (
                            <LoaderItem />
                        ) : (
                            <div className={styles.emptyText}>{translate('noDevicesForLicense')}</div>
                        )}
                        <div className={cn(styles.buttons, styles.closeButton)}>
                            <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                                {translate('close')}
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
